/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAIConfigSandboxPersonasPathParams = NonNullable<
  operations['postAIConfigSandboxPersonas']['parameters']['path']
>;

export interface Input extends PostAIConfigSandboxPersonasPathParams {
  apiVersion?: string;
  header: NonNullable<operations['postAIConfigSandboxPersonas']['parameters']['header']>;
}

export async function postAIConfigSandboxPersonas(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/ai-configs/{configKey}/sandbox/personas', {
    params: { path, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
